import timm from 'timm';

import {
  Types,
}            from 'app/actions/company-admin/employee-donations';
import utils from 'app/reducers/utils';

const initialState = {
  changeCampaignPending: {},
  reprocessPending: {},
};

const reducer = utils.createReducer(initialState, {

  [`${Types.CHANGE_CAMPAIGN}_PENDING`]: (state, action) => {
    return timm.setIn(state, ['changeCampaignPending', action.edId], true);
  },
  [`${Types.CHANGE_CAMPAIGN}_RESOLVED`]: (state, action) => {
    return timm.setIn(state, ['changeCampaignPending', action.edId], false);
  },
  [`${Types.CHANGE_CAMPAIGN}_REJECTED`]: (state, action) => {
    return timm.setIn(state, ['changeCampaignPending', action.edId], false);
  },

  [`${Types.REPROCESS}_PENDING`]: (state, action) => {
    return timm.setIn(state, ['reprocessPending', action.edId], true);
  },
  [`${Types.REPROCESS}_RESOLVED`]: (state, action) => {
    return timm.setIn(state, ['reprocessPending', action.edId], false);
  },
  [`${Types.REPROCESS}_REJECTED`]: (state, action) => {
    return timm.setIn(state, ['reprocessPending', action.edId], false);
  },

});

export default reducer;
